import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getGuppies } from '../services/firestoreService';
import GuppyCard from './GuppyCard';

const CategoryScreen = () => {
  const { category } = useParams(); // Get the category from the URL
  const [guppies, setGuppies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGuppies = async () => {
      const allGuppies = await getGuppies();
      const filteredGuppies = allGuppies.filter(guppy => guppy.name === category);
      setGuppies(filteredGuppies);
      setLoading(false);
    };
    fetchGuppies();
  }, [category]);

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '20px' }}>Loading...</div>;
  }

  if (guppies.length === 0) {
    return <div style={{ textAlign: 'center', marginTop: '20px' }}>No guppies in this category.</div>;
  }

  return (
    <div style={{ padding: '10px' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>{category}</h1>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '10px',
        }}
      >
        {guppies.map(guppy => (
          <GuppyCard key={guppy.guppyNumber} guppy={guppy} />
        ))}
      </div>
    </div>
  );
};

export default CategoryScreen;